import { Component } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { Municipality, MunicipalityService } from '../core/municipality.service';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  imports: [ButtonDirective, TranslatePipe, NgIf, NgFor, AsyncPipe],
})
export class HomeComponent {
  municipalities: Municipality[] = this.municipalityService.getAll();
  current$ = this.municipalityService.current$;

  constructor(
    public translate: TranslateService,
    private municipalityService: MunicipalityService,
    private router: Router,
  ) {}

  switchLanguage(lang: 'en' | 'it') {
    this.translate.use(lang);
  }

  selectMunicipality(id: string) {
    this.municipalityService.setCurrent(id);
    // Μετά την επιλογή, πηγαίνουμε στη νέα οθόνη υπηρεσιών
    this.router.navigateByUrl('/services');
  }
}
